var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"d-flex pa-4 text-center align-center justify-center text-button transition",attrs:{"block":"","x-large":"","color":_vm.color,"outlined":!_vm.state},on:{"click":function($event){_vm.state = !_vm.state}}},[_vm._v(" "+_vm._s(_vm.text)+": "+_vm._s(_vm.state ? "Sí" : "No")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }